<template>
    <div class="fixed top-[50%] left-10 hidden space-y-3 lg:block">
        <button
            class="flex h-16 w-16 items-center justify-center rounded-full bg-facebook text-xl text-white hover:opacity-90"
            @click.prevent="shareOnFacebook"
        >
            <IconBrandFacebook :size="32" />
        </button>

        <button
            class="flex h-16 w-16 items-center justify-center rounded-full bg-linkedin text-xl text-white hover:opacity-90"
            @click.prevent="shareOnLinkedin"
        >
            <IconBrandLinkedin :size="32" />
        </button>
    </div>
</template>

<script setup>
    import { IconBrandFacebook, IconBrandLinkedin, IconBrandTwitter } from '@tabler/icons-vue';

    function share(url, title, width = 640, height = 320) {
        let windowLeft = window.screenLeft || window.screenX;
        let windowTop = window.screenTop || window.screenY;
        let windowWidth = window.innerWidth || document.documentElement.clientWidth;
        let windowHeight = window.innerHeight || document.documentElement.clientHeight;
        let popupLeft = windowLeft + windowWidth / 2 - width / 2;
        let popupTop = windowTop + windowHeight / 2 - height / 2;
        let popup = window.open(
            url,
            title,
            'scrollbars=yes, width=' + width + ', height=' + height + ', top=' + popupTop + ', left=' + popupLeft
        );
        popup.focus();
        return true;
    }

    function shareOnFacebook() {
        let url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
        share(url, 'Partager sur facebook');
    }

    function shareOnTwitter() {
        let url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(document.title)}&via=Aeroemploi&url=${encodeURIComponent(
            window.location.href
        )}`;
        share(url, 'Partager sur Twitter');
    }

    function shareOnLinkedin() {
        let url = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(window.location.href)}`;
        share(url, 'Partager sur Linkedin');
    }
</script>
